import React from 'react'
import createSvgIcon from 'client/icons/createSvgIcon'

export default createSvgIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M15.2 2.03915L16.5 2.33857C19.1 3.0372 21 5.4325 21 8.22702V15.0137C21 15.6125 20.6 16.0117 20 16.0117H16V21.002C16 21.6008 15.6 22 15 22C14.4 22 14 21.6008 14 21.002V3.0372C14 2.73778 14.1 2.43837 14.3 2.23876C14.6 2.03915 14.9 1.93935 15.2 2.03915ZM16 14.0157H19V8.22702C19 6.33074 17.8 4.83367 16 4.33465V14.0157ZM9 3.0371C9 2.43828 9.4 2.03906 10 2.03906C10.6 2.03906 11 2.43828 11 3.0371V11.0214C11 11.6203 10.6 12.0195 10 12.0195H8V21.0019C8 21.6007 7.6 21.9999 7 21.9999C6.4 21.9999 6 21.6007 6 21.0019V12.0195H4C3.4 12.0195 3 11.6203 3 11.0214V3.0371C3 2.43828 3.4 2.03906 4 2.03906C4.6 2.03906 5 2.43828 5 3.0371V10.0234H6V3.0371C6 2.43828 6.4 2.03906 7 2.03906C7.6 2.03906 8 2.43828 8 3.0371V10.0234H9V3.0371Z"
  />,
  'FoodAndDrink'
)
